import _ from 'lodash';
import React from 'react';
import s from './with-dimensions.scss';
export function withDimensions(Component) {
    class WithDimensions extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                width: 0,
                height: 0,
            };
            this.container = React.createRef();
            this.update = _.debounce(() => { var _a, _b; return this.setState({ width: (_a = this.container.current) === null || _a === void 0 ? void 0 : _a.clientWidth, height: (_b = this.container.current) === null || _b === void 0 ? void 0 : _b.clientHeight }); }, 250, { trailing: true, leading: false });
            this.getWidth = () => { var _a; return (_a = this.container.current) === null || _a === void 0 ? void 0 : _a.clientWidth; };
            this.getHeight = () => { var _a; return (_a = this.container.current) === null || _a === void 0 ? void 0 : _a.clientHeight; };
        }
        componentDidMount() {
            window.addEventListener('resize', this.update);
            this.forceUpdate();
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.update);
        }
        componentDidUpdate() {
            if (this.state.width !== this.getWidth() || this.state.height !== this.getHeight()) {
                this.update();
            }
        }
        render() {
            return (React.createElement("div", { className: s.container, ref: this.container },
                React.createElement(Component, Object.assign({}, this.props, { width: this.getWidth(), height: this.getHeight() }))));
        }
    }
    return WithDimensions;
}
//# sourceMappingURL=with-dimensions.js.map